"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
exports.__esModule = true;
exports.KPayService = void 0;
/**
 * Kushki Service file
 */
var Identifiers_1 = require("./../../lib/constant/Identifiers");
var inversify_1 = require("inversify");
require("reflect-metadata");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
/**
 * Implementation
 */
var KPayService = /** @class */ (function () {
    function KPayService(gateway, authService) {
        this._gateway = gateway;
        this._authService = authService;
    }
    KPayService.prototype.deletePaymentMethod = function (body, mid, isTest, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.concatMap(function () { return _this._authService.getAuthorizationToken(); }), operators_1.concatMap(function (jwt) {
            return _this._gateway.deletePaymentMethod(body, isTest, regional, mid, jwt);
        }));
    };
    KPayService.prototype.requestSavedPaymentMethods = function (body, mid, isTest, regional) {
        return this._gateway.requestSavedPaymentMethods(body, isTest, regional, mid);
    };
    KPayService = __decorate([
        inversify_1.injectable(),
        __param(0, inversify_1.inject(Identifiers_1.IDENTIFIERS.KushkiGateway)),
        __param(1, inversify_1.inject(Identifiers_1.IDENTIFIERS.AuthService)),
        __metadata("design:paramtypes", [Object, Object])
    ], KPayService);
    return KPayService;
}());
exports.KPayService = KPayService;
